import {Component, Input, OnInit} from '@angular/core';
import {ErrorEntry} from "@flowmaps-com/flowmaps-typescriptmodels";
import {RefdataUtils} from "../../refdata/refdata-utils";

@Component({
  selector: 'app-issue-entry',
  templateUrl: './issue-entry.component.html',
  styleUrls: ['./issue-entry.component.scss']
})
export class IssueEntryComponent implements OnInit {
  @Input() entry: ErrorEntry;

  private readonly logsUrl = 'https://dashboard.fluxzero.io/organisation/a884923ee7c1480881395ae6028d3ff6/cluster/7d09ea3b1a6645fdbe4a65b969749fb9/logs';

  formattedLevel: string;
  formattedEnvironment: string;
  isFullStackTraceDisplayed: boolean = true;

  ngOnInit(): void {
    this.formatEnumValues();
  }

  toggleStackTrace() {
    this.isFullStackTraceDisplayed = !this.isFullStackTraceDisplayed;
  }

  getStackTrace(): string {
    if (this.isFullStackTraceDisplayed) {
      return this.entry.errorDetails.stackTrace;
    } else {
      return this.entry.errorDetails.stackTrace
        .split('\n')
        .filter(line => line.trim().startsWith('at com.flowmaps.'))
        .join('\n');
    }
  }

  formatEnumValues(): void {
    this.formattedLevel = RefdataUtils.enumFormatter(this.entry.errorDetails.level);
    this.formattedEnvironment = RefdataUtils.enumFormatter(this.entry.errorDetails.environment);
  }

  getLogSearchUrl(fieldValue: string, appendLongSuffix: boolean = false): string {
    const query = appendLongSuffix && fieldValue && !fieldValue.endsWith('L') ? `${fieldValue}L` : fieldValue;
    const params = new URLSearchParams({
      from: 'now-1y',
      to: 'now',
      q: query,
      childPath: '/messages'
    });

    return `${this.logsUrl}?${params.toString()}`;
  }
}
